import React from 'react';
import Routes from './Routes';
import { SelectPartnerProvider } from './hook/partner/useSelectPartner';

const App: React.FC = () => {
  return (
    <SelectPartnerProvider>
      <Routes />
    </SelectPartnerProvider>
  );
};

export default App;
